import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { authService } from '@/services/auth'
import { Alert, Card, Spinner } from '@agion/ui'
import { Logo } from '@/components/common/Logo'

export const LogoutPage = () => {
  const { t } = useTranslation('auth')
  const [error, setError] = useState<string>('')

  useEffect(() => {
    const handleLogout = async () => {
      try {
        await authService.logout()
        window.location.href = '/login'
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : t('logout.error')
        console.error('Logout error:', err)
        setError(errorMessage)

        setTimeout(() => {
          window.location.href = '/login'
        }, 3000)
      }
    }

    handleLogout()
  }, [t])

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <Logo className="h-12 mx-auto mb-6" theme="auto" />

        <Card className="p-6">
          {error ? (
            <>
              <Alert variant="error" className="mb-4">{error}</Alert>
              <p className="text-muted-foreground text-sm">{t('logout.redirecting')}</p>
            </>
          ) : (
            <>
              <div className="flex justify-center mb-4">
                <Spinner className="h-12 w-12" />
              </div>
              <p className="text-muted-foreground">{t('logout.signingOut')}</p>
            </>
          )}
        </Card>
      </div>
    </div>
  )
}
